import { colors } from '~styles';
import { breakpoints } from '~styles/metrics';
import { transparentize } from 'polished';
import { GeneralStyleProps } from 'src/@types/general';
import styled from 'styled-components';

export const Container = styled.div<GeneralStyleProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  position: relative;
  width: ${(props) => {
    if (props.width) {
      return `${props.width}%`;
    }

    if (props.fitContent) {
      return 'fit-content';
    }

    return '100%';
  }};
  min-width: 103px;
  height: 42px;
  border-radius: 44px;
  background-color: ${(props) => props.backgroundColor || colors.gray};
  transition: all ease-out 0.3s;

  padding: 10px 15px 10px 15px;

  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  user-select: none;

  opacity: ${(props) => props.disabled && 0.5};

  :hover {
    background-color: ${(props) => props.backgroundColorHover || '#E7E8ED'};
    transition: all ease-out 0.3s;

    .hover-animation {
      margin-top: -2px;
      transition: all ease-out 0.3s;
    }
  }

  svg {
    margin-right: 8px;
    color: ${(props) => (props.backgroundColor ? colors.white : colors.black)};
  }

  .hover-animation {
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all ease-out 0.3s;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    justify-content: flex-start;
    height: 100px;
    padding: 0;
    border-radius: 10px;

    .hover-animation {
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      height: 100%;

      padding: 15px;
    }
  }

  & > .ripple {
    width: 20px;
    height: 20px;
    position: absolute;
    background: ${transparentize(0.7, colors.newBlue)};
    display: block;
    content: "";
    border-radius: 9999px;
    opacity: 1;
    animation: 0.9s ease 1 forwards ripple-effect;
  }

  @keyframes ripple-effect {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(10);
      opacity: 0.375;
    }
    100% {
      transform: scale(35);
      opacity: 0;
    }
  }
`;
